import { render } from "./SiteNav.vue?vue&type=template&id=66ad5a4e"
import script from "./SiteNav.vue?vue&type=script&lang=js"
export * from "./SiteNav.vue?vue&type=script&lang=js"
script.render = render

export default script